<template>
  <SignApp />
</template>

<script>
import SignApp from "./components/SignApp";

export default {
  name: "App",
  components: {
    SignApp,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
}
</style>
